module.exports = __webpack_public_path__ + "img/rating_system.9ee4d9ab.png";